// 输入框基础组件
<template>
<div class="u-ipt">
  <div class='ipt_wrap' :class="size">
    <input ref="input"
  :value="currentValue"
  :name="name"
  :placeholder="placeholder"
  :disabled="disabled"
  :type="type"
  :maxlength="maxlength"
  @input="onInput"
  @focus="onFocus"
  @blur="onBlur"
  autocomplete="off"
  spellcheck="false"
  />
  <div class="ipt_extend">
    <i :class="del_icon_clazz" v-show="currentValue" @click="onDelete">
      <svg
        class="icon "
        aria-hidden="true"
      >
        <use :xlink:href="'#' + icontype" />
      </svg>
    </i>
    <!--具名插槽 icon-button-->
    <slot name="icon-button"></slot>
  </div>
  <!--具名插槽 button-->
  <slot name="button"></slot>
  </div>
  <!--匿名插槽-->
  <slot></slot>
</div>
</template>
<script>
export default {
  name: 'urs-input',
  /**
   * 接收的父组件数据
   * */
  props: {
    placeholder: String,
    icontype:{
      type: String,
      default: 'icon-ic-clear'
    },
    type: {
      type: String,
      default: 'text'
    },
    name: String,
    disabled: Boolean,
    initialValue: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: undefined
    },
    del_icon_clazz: {
      type: String,
      default: 'i-icon i-icon-delete'
    },
    size: {
      type: String,
      default: 'large'
    },
    validate: {
      type: Function,
      default: ()=>{
        return 1;
      }
    }
  },
  data () {
    return {
      currentValue:this.initialValue,
    }
  },
  watch: {
    initialValue (val) {
      this.currentValue = this.initialValue
    }
  },
  methods: {
    /**
     * 输入框聚焦
    */
    focus () {
      this.$refs.input.focus();
    },
    /**
     * 输入框失焦
    */
    blur () {
      this.$refs.input.blur();
    },
    /**
     * 设置输入框值
    */
    setCurrentValue (value) {
      if(value === this.currentValue) return;
      this.currentValue = value;
    },
    /**
     * 输入框输入事件处理
    */
    onInput (event) {
      // 更新值
      const value = event.target.value;
      this.setCurrentValue(value);
      // @TODO 清除掉错误样式
      // 移动端无独立错误样式 暂不做
      this.$emit('input',value);
    },
    /**
     * 输入框失焦事件处理
    */
    onBlur (event) {
      // @TODO 校验
      // 移动端都是点击按钮时校验 暂不做
      this.$emit('blur',this.currentValue);
    },
    /**
     * 输入框聚焦事件处理
    */
    onFocus (event) {
       var parent = this.$parent;
       if(parent&&parent.$options.name=='form-item'){
            parent.setMsg('');
       }
      this.$emit('focus',this.currentValue);
    },
    /**
     * 点击删除按钮事件处理
    */
    onDelete (event) {
      this.setCurrentValue('');
      this.$emit('delete');
    }
  }
}
</script>

<style lang=scss>
@mixin clearfloat() {
    zoom:1;
    &:after{display:block;clear:both;visibility:hidden;height:0;overflow:hidden;content:".";}
}

$u-input_border : #cccccc;
$u-input_placeholder: #cccccc;
$u-input_error: #d64343;

.u-ipt{
    display: block;
    width: auto;
    height: auto;
    position: relative;
    text-align: left;
    .ipt_wrap{
        display: block;
        padding: 0 .8rem 0 .4rem;
        position: relative;
        border:1px solid $u-input_border;
        border-radius: 4px;
        input{
          display: block;
          border: none;
          font-size: 0.28rem;
          height: 1rem;
          width: 100%;
          padding: 0;
          line-height: .28rem;
          &.error{

          }

        }
        .ipt_extend{
        position: absolute;
        top: .31rem;
        right: .1rem;
        background: #fff;
        &>i{
            margin-right:12px;
            cursor: pointer;
        }
        }
        &.small{
          padding-right: 2rem;
          .ipt_extend{
            right: 2.2rem;
          }
        }
    }
    @include clearfloat();
}
</style>




// WEBPACK FOOTER //
// Uinput.vue?2bbbb86d